import { Button, H2, InputIcon, InputText } from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { twMerge } from "tailwind-merge";
import { SpinnerLegacy } from "../../../../components";
import { InputContainer } from "@sellar-io/components";
import { BusinessSwitcherContent } from "../../../../components/menu/dialogs/BusinessSwitcherContent";
import { useSellarUser } from "../../../../hooks";
import { useBusinessList } from "../../../../hooks/api/v2/business/useBusinessList";
import { useFirebaseUser } from "../../../../hooks/useFirebaseUser.shared";
import {
  SignupFlowStep,
  useSignupContext,
} from "../../../../hooks/useSignupContext.shared";
import { deleteUnauthenticatedDraftBasket } from "../deleteUnauthenticatedDraftBasket";

export function UserSignupBusinessSelectStep({
  supplierId,
}: {
  supplierId: number;
}): ReactElement {
  const [searchValue, setSearchValue] = useState("");
  const { setStep, setBuyerSelectBusinessId, endOnboarding } =
    useSignupContext();
  const { user } = useSellarUser();
  const { user: firebaseUser } = useFirebaseUser();
  const businessFormStep = {
    ...SignupFlowStep.BuyerCreationStep,
    backStep: SignupFlowStep.BusinessSelectStep.name,
    step: 3,
  };
  const businessesQuery = useBusinessList(
    {
      query: [
        ...(user?.type !== "admin"
          ? [
              Object.freeze({
                type: "hasMembership",
                modifier: "EQUALS",
                value: true,
              }),
            ]
          : []),
        Object.freeze({
          type: "type",
          modifier: "EQUALS",
          value: "retailer",
        }),
      ],
      sort: [
        {
          direction: "asc",
          type: "type",
        },
        {
          direction: "asc",
          type: "name",
        },
      ],
      limit: 10,
    },
    {
      enabled: !!firebaseUser && !!user,
    },
  );

  const setNextStep = () => {
    SignupFlowStep.BuyerCreationStep = businessFormStep;
    setStep(businessFormStep);
  };
  if (businessesQuery.isLoading) return <SpinnerLegacy />;
  return (
    <div
      className={twMerge(
        "m-auto flex h-full w-full flex-col gap-4 overflow-auto lg:h-[480px]",
        !businessesQuery.data?.pages[0]?.length && "justify-center",
      )}
    >
      {!!businessesQuery.data?.pages[0]?.length ? (
        <>
          <div className={"flex flex-col gap-2"}>
            <H2 className={"text-center"}>
              Which business are you ordering for?
            </H2>
          </div>
          <div className={"w-full"}>
            <InputContainer className={"w-full"}>
              <InputIcon icon={"MAGNIFY"} />
              <InputText
                required={false}
                placeholder={"Search..."}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </InputContainer>
          </div>
          <BusinessSwitcherContent
            searchValue={searchValue}
            type={"retailer"}
            onClick={async (businessId) => {
              setBuyerSelectBusinessId(businessId);
              setStep(SignupFlowStep.ConfirmationStep);
            }}
          />
          <Button className={"w-full"} onClick={() => setNextStep()}>
            Create new buyer account
          </Button>
        </>
      ) : (
        <>
          <H2 className={"text-center"}>
            You need a buyer account to place orders on Sellar
          </H2>
          <p>
            It looks like you're set up as a <strong>supplier</strong> on
            Sellar. You can use your existing login details to set up your buyer
            account and complete your order.
          </p>
          <Button className={"w-full"} onClick={() => setNextStep()}>
            Continue
          </Button>
          <Button
            color={"red"}
            className={"w-full"}
            onClick={async () => {
              await deleteUnauthenticatedDraftBasket({ supplierId });
              endOnboarding();
            }}
          >
            Discard and return to supplier account
          </Button>
        </>
      )}
    </div>
  );
}
